module.exports = __webpack_public_path__ + "images/Avalara-26fe38.png";